import i from './tariff-simulation-release-search.container';

export default i;
